import ActiveItemDivider from 'components/active-item/ActiveItemDivider';
import { useRefreshItems } from 'hooks/useRefreshItems';
import { useSoundPath } from 'hooks/useSoundPath';
import { PrizesContext } from 'pages/Prizes';
import React, { useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { createAPI } from 'services/api/api';
import { setError } from 'store/user';

const CombinePrizes = () => {
  const api = createAPI();
  const refresh = useRefreshItems();
  const playSound = useSoundPath();
  const dispatch = useDispatch();
  const { selectMode, setSelectMode, selectedItems, setSelectedItems } = useContext(PrizesContext);
  const [combineText, setCombineText] = useState('Cards');
  const [combineHint, setCombineHint] = useState('Combine two or more prize cards into a single card. The new card prize amount will be the sum of the combined cards.');

  const getSum = () => {
    if (selectedItems) {
      return selectedItems.reduce((total, prize) => total + prize.cost, 0);
    }
  }

  const combineCards = async () => {
    playSound('main');
    const selectedIds = selectedItems.map((prize) => prize.id);
    const payload = {ids: selectedIds};

    await api.post(`/prize/combined_prize`, payload)
      .then(() => {
        setSelectedItems([]);
        setSelectMode(false);
        refresh();
        window.scrollTo(0, 0);
      })
      .catch((error) => {
        console.log(error)
        dispatch(setError(error.response.data.message))
      })
  }



  useEffect(() => {
    if (selectedItems.length < 2) {
      setCombineText('Cards');
      setCombineHint('Combine two or more prize cards into a single card. The new card prize amount will be the sum of the combined cards.')
    } else {
      setCombineText(`(${selectedItems.length}) - $${getSum()}`)
    }

    if (selectMode === true) setCombineHint('Select two or more prize cards to combine into a single card. The new prize card value will be the sum of the combined cards.');
  }, [selectedItems])

  return (
    <>
      <section className="card-details__combine">
        <h3 className="card-details__combine-title">Combine Prize Cards</h3>
        <div className="card-details__combine-actions">
          <button
            className={`card-details__combine-action card-details__combine-action--select ${selectMode === true ? 'card-details__combine-action--close' : ''}`}
            onClick={() => {
              playSound('main');
              setSelectMode(!selectMode)
              setSelectedItems([]);
            }}
          >
            {
              selectMode === false ?
                'Select Cards To Combine'
                :
                'Cancel'
            }
          </button>
          {
            selectMode === true && <button
            className="card-details__combine-action card-details__button--craft"
            disabled={selectedItems.length < 2 || getSum() > 50}
            type="button"
            onClick={combineCards}
          >
            Combine {combineText}
          </button>
          }
        </div>
        <p className="card-details__combine-hint">
          {combineHint}
          {selectMode && <p className='card-details__combine-hint-warning'>$50 is Maximum Prize Card Combination</p>}
        </p>
      </section>
      <ActiveItemDivider />
    </>
  )
}

export default CombinePrizes
